import React from "react";
import { Form, Formik } from "formik";
import closeIcon from "../../assets/icons/close-icon.svg";
import FilterTextField from "./filter-input-fields/filter-text-field";
import { useLocation, useNavigate } from "react-router-dom";

const AdminFilterDrawer = ({ open, onClose = () => {} }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParamsData = new URLSearchParams(location.search);
  const name = queryParamsData.get("search") ?? "";

  const initialValues = {
    search: name ?? "",
  };
  const handleSubmit = (values) => {
    navigate(`/admin/users/list?search=${values?.search ?? ""}`);
    onClose();
  };

  const clearFilter = () => {
    navigate(`${location.pathname}`);
    onClose();
  };
  return (
    <div
      className={`
          fixed top-0 right-0 h-full w-full max-w-[30rem] bg-white shadow-lg z-50 p-5
          transform transition-transform duration-300 ease-in-out
          ${open ? "translate-x-0" : "translate-x-full"}
        `}
    >
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        enableReinitialize={true}
      >
        {({ values, resetForm }) => (
          <Form>
            <div className="flex items-center justify-between w-full">
              <h3 className="text-lg font-bold mb-4">Filters</h3>
              <button
                type="button"
                className="p-1 bg-gray-100 rounded-full"
                onClick={onClose}
              >
                <img src={closeIcon} alt="X" width={24} height={24} />
              </button>
            </div>

            <div className="h-screen max-h-[calc(100vh-10rem)] overflow-auto">
              <FilterTextField
                name={"search"}
                label={"Name"}
                placeholder={`Enter Name`}
              />
            </div>
            <div className="flex justify-end gap-2 p-2 mt-2">
              <button
                type="submit"
                className="px-4 py-2 bg-blue-600 text-white rounded"
              >
                Apply Filters
              </button>
              <button
                onClick={() => {
                  clearFilter();
                  resetForm();
                }}
                type="button"
                className="px-4 py-2 bg-secondary text-white rounded"
              >
                Clear Filters
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default AdminFilterDrawer;
